import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import {transformResultsFromObject} from 'util/data';
import {TIMEOUT_STORE} from 'util/constants';

import endpoints from 'config/endpoints';

const vendorAlias = {
    GCLOUD: 'GCP',
    GCP:    'GCLOUD'
};

export const vendorCodes = {
    aws:       'AWS',
    azure:     'AZURE',
    azure_csp: 'AZURE_CSP',
    vcloud:    'VCLOUD',
    itconic:   'ITCONIC',
    gcloud:    'GCLOUD',
    oracle:    'ORACLE',
    alicloud:  'ALICLOUD'
};
const mapVendorsCode = {
    AWS:       'aws',
    AZURE:     'azure',
    AZURE_CSP: 'azure_csp',
    VCLOUD:    'vcloud',
    ITCONIC:   'itconic',
    GCLOUD:    'gcloud',
    ORACLE:    'oracle',
    ALICLOUD:  'alicloud'
};
const vendorColors = {
    AWS:       '#53B7E8',
    AZURE:     '#4393CF',
    AZURE_CSP: '#2e6690',
    VCLOUD:    '#FFC814',
    ITCONIC:   '#E56D64',
    GCLOUD:    '#23ba93',
    ORACLE:    '#d83124',
    ALICLOUD:  '#5a646a'
};

const getVendorColor = index => vendorColors[index];

const exports = storeModuleFactory({
    name:               'vendors',
    timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
    endpoint:           endpoints.vendors.endpoint,
    instanceEndpoint:   endpoints.vendors.instanceEndpoint,
    transformResultsFn: json => transformResultsFromObject(json.results)
});

exports.vendorCodes = vendorCodes;
exports.mapVendorsCode = mapVendorsCode;
exports.getVendorColor = getVendorColor;
exports.getVendorIcon = vendorCode => mapVendorsCode[vendorCode];
exports.vendorAlias = vendorAlias;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/vendors.js